import Styled, { css } from 'styled-components';

import { media } from '../../../../lib/StyledComponents/StyledComponents';
import { cssDeclaration } from '../../Utils';

interface IStyledFooterLinkProps {
  hideOnMobile: boolean;
  hideOnDesktop: boolean;
}

export const StyledFooterLink = Styled.a<IStyledFooterLinkProps>`

  ${({ theme: { themeTwo }, hideOnDesktop, hideOnMobile }) => {
    const { layout: { footer: { link } }} = themeTwo;

    return css`
      text-decoration: none;
      transition: color 100ms ease-out;
      line-height: ${link.font.lineHeight};
      /* font-family */ ${link.font.family};
      /* text-align */ ${cssDeclaration(themeTwo, 'text-align', link.font.align)};
      /* font-weight */ ${cssDeclaration(themeTwo, 'font-weight', link.font.weight)};
      /* font-size */ ${cssDeclaration(themeTwo, 'font-size', link.font.size)};
      /* color */ ${cssDeclaration(themeTwo, 'color', link.font.color)};

      /* padding */ ${cssDeclaration(themeTwo, 'padding', link.padding)};
      /* background-color */ ${cssDeclaration(themeTwo, 'background-color', link.backgroundColor)};
      /* border */ ${cssDeclaration(themeTwo, 'border', link.border)};
      /* margin */ ${cssDeclaration(themeTwo, 'margin', link.margin)};

      &:last-of-type {
        margin-right: 0;
      }

      ${hideOnMobile && css`
        display: none;

        ${media.small`
          display: flex;
        `}
      `}

      ${hideOnDesktop && css`
        ${media.small`
          display: none;
        `}
      `}

      &:hover {
        /* color */
        ${link.state.hover.font && link.state.hover.font.color &&
          cssDeclaration(themeTwo, 'color', link.state.hover.font.color)
        };
      }
    `;
  }}
`;
